/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Progress/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Progress({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Progress"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let questionIsInformationOnlyValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'isInformationOnly',
})
let widgetSettingsShowprogressbarValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'settings.showProgressBar',
})
let aggregateData = fromHelpers.getView(questionIsInformationOnlyValueData, widgetSettingsShowprogressbarValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}